import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import TaskListRow from './TaskListRow';
import { ITask } from '@/api/tasks/types';
import { useAssignedUsers } from '@/features/projects/hooks/useAssignedUsers';
import { useGetAllCommentsByTask } from '@/features/projects/hooks/comments/useGetAllCommentsByTask';
import { useGetAllDocsByTask } from '@/features/projects/hooks/tasks/useGetAllDocsByTask';
import detailProjectStyles from '@features/projects/styles/detailproject.module.scss';

interface SortableTaskListRowProps {
  task: ITask;
  idx: number;
  selectTask: (task: ITask) => void;
}

const SortableTaskListRow = ({ task, idx, selectTask }: SortableTaskListRowProps) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: task.id });

  const { userAssigned } = useAssignedUsers({ taskId: task.id });
  const { comments } = useGetAllCommentsByTask(task.id);
  const { docs } = useGetAllDocsByTask(task.id);

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0 : 1,
    zIndex: isDragging ? 0 : 'auto',
  };

  if (isDragging) {
    return (
      <tr ref={setNodeRef}>
        <td colSpan={6} className={detailProjectStyles["task-table__placeholder-cell"]}>
          &nbsp;
        </td>
      </tr>
    );
  }

  let status: 'completado' | 'en progreso' | 'pendiente' = 'pendiente';
  if (task.state === 'completada') status = 'completado';
  else if (task.state === 'en progreso') status = 'en progreso';

  return (
    <tr 
      ref={setNodeRef} 
      style={style} 
      className={detailProjectStyles["task-table__row"]} 
      {...attributes} 
      {...listeners}
    >
      <TaskListRow
        index={idx}
        title={task.title}
        assignees={userAssigned.map(u => ({
          name: `${u.firstname} ${u.firstlastname}`.trim(),
          avatarUrl: u.picture || undefined,
        }))}
        dateRange={task.startDate && task.endDate ? { start: task.startDate, end: task.endDate } : undefined}
        status={status}
        commentsCount={Array.isArray(comments) ? comments.length : 0}
        attachmentsCount={Array.isArray(docs) ? docs.length : 0}
        onEdit={() => selectTask(task)}
        onTitleClick={() => selectTask(task)}
        onMenu={() => {}}
        styles={detailProjectStyles}
      />
    </tr>
  );
};

export default SortableTaskListRow; 